import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../api';

const PACKAGES = [
  { credits: 1000,   price: 9,   priceId: 'price_1Tc5EFRt0Jedzzf8exyoeyQN', popular: false },
  { credits: 5000,   price: 45,  priceId: 'price_1Tc5EZRt0Jedzzf867Jt0lxP', popular: false },
  { credits: 25000,  price: 225, priceId: 'price_1Tc5FCRt0Jedzzf8PreMciZK', popular: true  },
  { credits: 100000, price: 900, priceId: 'price_1Tc5FXRt0Jedzzf8NvEFu0nC', popular: false },
];

const COSTS = [
  { label: '1 text message sent',   cost: '1 credit — $0.009' },
  { label: '1 AI-generated reply',  cost: '2 credits — $0.018' },
];

export default function Credits() {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const success = params.get('success');
  const cancelled = params.get('cancelled');

  useEffect(() => {
    api.getCredits().then(d => setBalance(d.credits || 0)).catch(() => {});
  }, [success]);

  const handleBuy = async (pkg) => {
    setLoading(pkg.priceId);
    try {
      const data = await api.createCheckout({ priceId: pkg.priceId });
      window.location.href = data.url;
    } catch (err) { alert(err.message); setLoading(null); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, maxWidth: 680 }}>
      {success && <div style={{ padding: '14px 20px', borderRadius: 12, background: 'rgba(29,158,117,0.1)', border: '0.5px solid rgba(29,158,117,0.3)', fontSize: 13, color: '#0F6E56', fontWeight: 500 }}>Payment successful! Credits added to your account.</div>}
      {cancelled && <div style={{ padding: '14px 20px', borderRadius: 12, background: 'rgba(224,92,92,0.08)', border: '0.5px solid rgba(224,92,92,0.2)', fontSize: 13, color: '#A32D2D' }}>Payment cancelled. No charges were made.</div>}

      <div style={{ background: 'var(--bg2)', borderRadius: 16, border: '0.5px solid rgba(83,74,183,0.3)', overflow: 'hidden', boxShadow: '0 0 30px rgba(83,74,183,0.08)' }}>
        <div style={{ padding: '14px 20px', borderBottom: '0.5px solid var(--border)', background: 'linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#534AB7', boxShadow: '0 0 8px #534AB7' }} />
          <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>Credit Balance</span>
        </div>
        <div style={{ padding: '24px 20px', display: 'flex', alignItems: 'center', gap: 24 }}>
          <div>
            <div style={{ fontSize: 52, fontWeight: 800, color: balance < 100 ? '#E05C5C' : '#534AB7', lineHeight: 1 }}>{balance.toLocaleString()}</div>
            <div style={{ fontSize: 13, color: 'var(--text2)', marginTop: 4 }}>credits remaining</div>
          </div>
          <div style={{ flex: 1, padding: '16px 20px', borderRadius: 12, background: 'var(--bg3)', border: '0.5px solid var(--border)' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text2)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.5px' }}>How credits work</div>
            {COSTS.map(item => (
              <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>
                <span>{item.label}</span>
                <span style={{ fontWeight: 700, color: '#534AB7' }}>{item.cost}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ background: 'var(--bg2)', borderRadius: 16, border: '0.5px solid rgba(83,74,183,0.3)', overflow: 'hidden', boxShadow: '0 0 30px rgba(83,74,183,0.08)' }}>
        <div style={{ padding: '14px 20px', borderBottom: '0.5px solid var(--border)', background: 'linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#1D9E75', boxShadow: '0 0 8px #1D9E75' }} />
          <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)' }}>Buy Credits</span>
          <span style={{ fontSize: 11, color: 'var(--text3)' }}>-- $0.009 per text</span>
        </div>
        <div style={{ padding: 20, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {PACKAGES.map(pkg => (
            <div key={pkg.priceId} style={{ padding: '20px', borderRadius: 12, border: '0.5px solid ' + (pkg.popular ? 'rgba(83,74,183,0.5)' : 'var(--border)'), background: pkg.popular ? 'rgba(83,74,183,0.05)' : 'var(--bg3)', position: 'relative' }}>
              {pkg.popular && <div style={{ position: 'absolute', top: -10, right: 14, fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20, background: 'linear-gradient(135deg,#534AB7,#1D9E75)', color: '#fff' }}>BEST VALUE</div>}
              <div style={{ fontSize: 28, fontWeight: 800, color: '#534AB7', lineHeight: 1 }}>{pkg.credits.toLocaleString()}</div>
              <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 12 }}>credits</div>
              <div style={{ fontSize: 24, fontWeight: 700, color: 'var(--text)', marginBottom: 4 }}>${pkg.price}</div>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 16 }}>$0.009 per text</div>
              <button onClick={() => handleBuy(pkg)} disabled={loading === pkg.priceId} style={{ width: '100%', padding: '10px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg,#534AB7,#1D9E75)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: loading === pkg.priceId ? 'not-allowed' : 'pointer', boxShadow: '0 4px 12px rgba(83,74,183,0.3)', opacity: loading === pkg.priceId ? 0.7 : 1 }}>
                {loading === pkg.priceId ? 'Loading...' : 'Buy now'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
